import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mhome/ui";

const DeleteAutomationDialog = ({ open, onClose, onDelete }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} variant="pops">
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this automation?
        </Typography>
      </DialogContent>
      <DialogActions className="justify-between">
        <Button onClick={onClose} variant="outline" className="normal-case">
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          variant="destructive"
          disabled={isDeleting}
          className="normal-case"
        >
          Delete
          {isDeleting && (
            <span className="ml-2 inline-flex items-center">
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-destructive-foreground border-t-transparent" />
            </span>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAutomationDialog;
